<template>
    <div class="app">
        <div class="bg"></div>
        <div class="head">
            <div class="logo"></div>
            <div class="line"></div>
            <div class="icon" :style="'background-image:url(' + projectIcon + ')'"></div>
            <div class="name">{{ projectName }}</div>
        </div>
        <div class="basicInfo">
            <div class="tem">
                <div>{{ weather }}</div>
                <div>{{ temperature }}℃</div>
            </div>
            <div class="hum">
                <div>湿度:</div>
                <div>{{ humidity }}%</div>
            </div>
            <div class="exit" @click="exit">
                <div class="icon"></div>
                <div>退出三维看板</div>
            </div>
        </div>
        <div class="time">{{ time }}</div>
        <router-view :key="$route.name + ($route.params.id || '')"></router-view>
    </div>
</template>

<script>
    import {
        GetBaseInfo,
        GetAllLoopsByProjectId,
        GetTransformerNum,
        GetAllAreas,
        GetAllSecurity,
        GetLoopMaster,
        GetLoadInfo,
        getCapacity
    } from "@/components/Request";
    import {
        subscribebySubLoopUrl
    } from "@/mqtt/index"

    export default {
        name: "App",
        data() {
            return {
                weather: "",
                temperature: "--",
                humidity: "--",
                time: "",
                projectName: "",
                projectIcon: "",
                projectCoordinate: ''
            };
        },
        // async beforeRouteEnter(to, from, next) {
        //     next(vm => {
        //         console.log(vm)
        //         GetAllAreas({
        //             projectId: vm.$store.state.projectId
        //         }).then(({
        //             data
        //         }) => {
        //             vm.$store.commit("set_val", {
        //                 allThreeUrl: data.data.areas
        //             })
        //             let surveillance = []
        //             new Promise((resolve) => {
        //                 data.data.areas.forEach(item => {
        //                     GetAllSecurity({
        //                         areaId: item.areaId
        //                     }).then(({
        //                         data
        //                     }) => {
        //                         surveillance.push({
        //                             areaId: item.areaId,
        //                             rooms: {
        //                                 types: ["监控列表", "门禁列表"],
        //                                 details: [
        //                                     data.data.devices
        //                                     .filter(item =>
        //                                         item
        //                                         .device_class_name ==
        //                                         '监控设备'
        //                                     ),
        //                                     [],
        //                                 ],
        //                             },
        //                         })
        //                     })
        //                 })
        //                 resolve()
        //             }).then(
        //                 vm.$store.commit("set_val", {
        //                     surveillance: surveillance
        //                 })
        //             )
        //         })
        //     })
        // },
        created() {
            GetAllAreas({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        allThreeUrl: data.data.areas
                    })
                    let surveillance = []
                    new Promise((resolve) => {
                        data.data.areas.forEach(item => {
                            GetAllSecurity({
                                areaId: item.areaId
                            }).then(({
                                data
                            }) => {
                                surveillance.push({
                                    areaId: item.areaId,
                                    rooms: {
                                        types: ["监控列表", "门禁列表"],
                                        details: [
                                            data.data.devices.filter(item =>
                                                item.device_class_name ==
                                                '监控设备'
                                            ),
                                            [],
                                        ],
                                    },
                                })
                            })
                        })
                        resolve()
                    }).then(() => {
                        this.$store.commit("set_val", {
                            surveillance: surveillance
                        })
                    })
                }),
                GetLoopMaster({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        loopMaster: data.data.loops
                    })
                    data.data.loops.forEach(item => {
                        subscribebySubLoopUrl([
                            item.subLoopUrl + '/P',
                        ])
                    })
                })
        },
        mounted() {
            window.addEventListener("message", this.handleMessage);
            // 区域总览信息
            GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.projectName = data.data.project.projectName
                this.projectIcon = data.data.project.projectIcon
                this.projectCoordinate = data.data.project.projectCoordinate
                this.$store.commit("set_val", {
                    // receivingCapacity: JSON.parse(data.data.project.projectDetailsInfo)['受电容量'],
                    voltageClass: JSON.parse(data.data.project.projectDetailsInfo)['供电电压']
                });
                this.getWeatherInfo(this.projectCoordinate)
            })

            // 动态时间显示
            setInterval(() => {
                this.time = this.dateFormat("YYYY.mm.dd HH:MM:SS", new Date());
            }, 1000);

            this.getLoadInfo()

            setInterval(() => {
                this.getWeatherInfo(this.projectCoordinate)
                this.getLoadInfo()
            }, 10 * 60 * 1000);

            // 获取当前项目变压器数量
            GetTransformerNum({
                projectId: this.$store.state.projectId,
            }).then(({
                data
            }) => {
                let datas = data.data.result
                if (datas && datas.find(item => item.type == '变压设备'))
                    this.$store.commit("set_val", {
                        transformerNum: datas.find(item => item.type == '变压设备').num
                    })
            }).catch(err => {
                console.log(err)
            })

            // GetAllLoopsByProjectId({
            //     projectId: this.$store.state.projectId
            // }).then(({
            //     data
            // }) => {
            //     let str = ''
            //     console.log(data.data.deviceLoops)
            //     data.data.deviceLoops.map((item, index) => {
            //         str = str.concat(item.loopName)
            //     })
            //     console.log(this.quchong4(str))
            // })
            getCapacity({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        receivingCapacity: data.data.res
                    });
                })
        },
        methods: {
            // getreceivingCapacity(){
                
            // },

            dateFormat(fmt, date) {
                let ret;
                const opt = {
                    "Y+": date.getFullYear().toString(), // 年
                    "m+": (date.getMonth() + 1).toString(), // 月
                    "d+": date.getDate().toString(), // 日
                    "H+": date.getHours().toString(), // 时
                    "M+": date.getMinutes().toString(), // 分
                    "S+": date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp("(" + k + ")").exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
                    }
                }
                return fmt;
            },
            getLoadInfo() {
                GetLoadInfo({
                    projectId: this.$store.state.projectId
                }).then(({
                    data
                }) => {
                    this.$store.commit("set_val", {
                        load: data.data.influxData.load
                    });
                })
            },
            getWeatherInfo(location) {
                // 天气信息
                // 420114 蔡甸区 昌华/凯骏
                // 420111 洪山区 留创园
                // 370827 鱼台县 鲁泰
                let id = 420111
                // // 高德api 100000/天 无法通过经纬度查询
                // fetch("https://restapi.amap.com/v3/weather/weatherInfo?city=" + id + "&key=3ecd07184027ff3342dc5f24551c2ecc")
                //     .then((response) => response.json())
                //     .then((json) => {
                //         const {
                //             temperature,
                //             weather,
                //             humidity
                //         } = json.lives[0];
                //         this.temperature = temperature;
                //         this.weather = weather;
                //         this.humidity = humidity;
                //     }).catch((e) => {
                //         return e;
                //     });

                // 和风天气api 10000/天 可通过经纬度查询
                fetch('https://devapi.heweather.net/v7/weather/now?location=' + location +
                        '&key=154645a21e7c47c4bb5f0657c7b1ad63')
                    .then(response => response.json())
                    .then(json => {
                        this.temperature = json.now.temp;
                        this.weather = json.now.text;
                        this.humidity = json.now.humidity;
                    })
            },
            exit() {
                window.parent.postMessage({
                    cmd: 'exit',
                }, '*');
            },
            handleMessage(event) {
                // console.log(event);
                const data = event.data;
                switch (data.cmd) {
                    case "loadEnd":
                        window.parent.postMessage({
                            cmd: 'loadEnd',
                        }, '*');
                        break;
                    case "loadProgress":
                        window.parent.postMessage({
                            cmd: 'loadProgress',
                            value: data.value
                        }, '*');
                        break;
                }
            },
            quchong4(str) {
                var obj = {};
                var newStr = "";
                for (var i = 0; i < str.length; i++) {
                    if (!obj[str[i]]) {
                        newStr += str[i];
                        obj[str[i]] = 1;
                    }
                }
                return newStr;
            }
        },
    };
</script>

<style lang="less" scoped>
    .app {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .bg {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-image: url("../assets/img/bg.png");
        background-size: 100% 100%;
        clip-path: polygon(0 0, 100% 0, 100% 12%, 12% 12%, 12% 88%, 88% 88%, 88% 12%, 100% 12%, 100% 100%, 0 100%, 0 0);
        z-index: 0;
    }

    .head {
        width: 6300/192vw;
        height: 720/108vh;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;

        .logo {
            width: 1080/192vw;
            height: 340/108vh;
            margin-left: 160/192vw;
            background-image: url("../assets/img/logo.png");
            background-size: 100% 100%;
        }

        .line {
            width: 20/192vw;
            height: 330/108vh;
            margin-left: 200/192vw;
            background: rgba(255, 255, 255, 0.3);
        }

        .icon {
            width: 300/192vw;
            height: 340/108vh;
            margin-left: 200/192vw;
            // background-color: #fff;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }

        .name {
            font-family: YouSheBiaoTiHei;
            color: #e6f3fd;
            font-size: 36rem;
            margin-left: 110/192vw;
        }
    }

    .basicInfo {
        // width: 2710/192vw;
        height: 160/108vh;
        position: fixed;
        top: 340/108vh;
        right: 470/192vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-family: YouSheBiaoTiHei;
        font-size: 22rem;
        color: #e6f3fdff;
    }

    .tem,
    .hum {
        width: 1200/192vw;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }

    .exit {
        margin-left: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        .icon {
            .w(15);
            .h(15);
            background: url('../assets/img/退出.png');
            background-size: 100% 100%;
            margin-right: 5px;
        }
    }

    .time {
        width: 1830/192vw;
        height: 110/108vh;
        position: fixed;
        left: 8680/192vw;
        top: 900/108vh;
        font-family: YouSheBiaoTiHei;
        font-size: 18rem;
        color: #e6f3fdff;
        white-space: nowrap;
    }
</style>